import module from 'contabilidad/clientescuentascontables/module.js'
import template from './template.html'

export class ContabilidadClientescuentascontablesComponent {
  data = null
  promise = null
  filtro = ''
  resultados = []

  constructor ($filter, ContabilidadClientesCuentasContables) {
    this.filterBy = $filter('filter')
    this.ContabilidadClientesCuentasContables = ContabilidadClientesCuentasContables
  }

  $onInit () {
    this.promise = this.ContabilidadClientesCuentasContables.obtenerClientes()
      .then(({data}) => (this.data = data))
      .then(() => (this.filtrar()))
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }
}

module.component('contabilidadClientescuentascontables', {
  controller: ContabilidadClientescuentascontablesComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/components/component.js